import { render } from "./RDFUpload.vue?vue&type=template&id=77b74146&scoped=true"
import script from "./RDFUpload.vue?vue&type=script&lang=js"
export * from "./RDFUpload.vue?vue&type=script&lang=js"

import "./RDFUpload.vue?vue&type=style&index=0&id=77b74146&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b74146"]])

export default __exports__